import { render, staticRenderFns } from "./inventoryStockGeneralSummaryWidget.vue?vue&type=template&id=b34f6d3e&"
import script from "./inventoryStockGeneralSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./inventoryStockGeneralSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports